import * as ol from 'openlayers'
import BasePointAspect from './BasePointAspect.js'

export default class DefaultAspect extends BasePointAspect {

	constructor (data, type) {
		super(data);

		this.existingIcons = ['Accident', 'Bus', 'BusStop', 'EmergencyService', 'RoadWork', 'TrafficJam'];
		this.type = type;

		//must match dss object type
		this.set('type', type);
	}

	createStyle () {
		let style = null

		if (this.existingIcons.indexOf(this.type) !== -1) {
			style = new ol.style.Style({
				image: new ol.style.Icon(/* @type {olx.style.IconOptions} */ ({
					anchorXUnits: 'fraction',
					anchorYUnits: 'fraction',
					src: this.getImagePath('Default/', this.type, '.svg'),
					anchor: [0.5, 0.5],
				}))
			})
		} else {
			style = new ol.style.Style({
				image: new ol.style.Circle({
					radius: 4,
					fill: new ol.style.Fill({
						color: '#000'
					})
				})
			})
		}

		return  [
			style
		];
	}
}
